module.exports = __webpack_public_path__ + "img/ch4.eb030095.jpg";